<template>
  <div class="my-videos-wrapper">
    <ListHeader class="vidoes-list-header" listTitle="我的视频" @query-list="getVideos"></ListHeader>
    <VideoList ref="videoListRef"></VideoList>
  </div>
</template>

<script>
import VideoList from './components/VideoList'
import ListHeader from '@components/list/listHeader'

export default {
  name: '',
  components: {
    VideoList,
    ListHeader
  },
  mounted() {
    this.$store.dispatch('common/login')
  },
  methods: {
    getVideos(val) {
      this.$refs.videoListRef.searchData = val
      this.$refs.videoListRef.getVideos(1)
      this.$refs.videoListRef.currentPageNo = 1
    }
  }
}
</script>
<style lang="scss">
.my-videos-wrapper {
  width: 100%;
  height: 100%;
  padding-left: 18px;
}
</style>
